import { CalendarProps } from '@/@types/calendar';
import { cn } from '@/entrypoints/utils';
import { useAtomValue } from 'jotai';
import React from 'react';
import { calendarConfigAtom } from './calendar-atoms';

type Props = {
  clinicId: string;
  clinicDetails: CalendarProps['clinics'][string];
  active: boolean;
};

function ClinicDetails({ clinicId, clinicDetails, active }: Props) {
  const { labels } = useAtomValue(calendarConfigAtom);
  return (
    <div
      className={cn('medispa-calendar_clinic-details', active && 'active')}
      data-product={clinicId}
    >
      <p>
        {labels.clinic.addressLabel.replace(/{{location_address}}/g, clinicDetails.address)} |{' '}
        {labels.clinic.phoneNumberLabel.replace(
          /{{location_phone}}/g,
          clinicDetails.display_phone_number,
        )}
      </p>
    </div>
  );
}

export default ClinicDetails;
